import React from 'react'
import '../styles/footer.css'
const Footer = () => {
  return (
    <section id='footer'>
      <small> &copy;Somesh | All rights reserved. </small>
    </section>
  )
}

export default Footer